import React, { useEffect, useState } from 'react';

import { connect } from 'react-redux';
import ModalLogin from '../scripts/components/global/modal-login';
import Header from '../scripts/components/global/header';
import { retrieveCountriesFromCMS } from '../redux/actions/countries';
import PropTypes from 'prop-types';

function ProtectedRoutes({
  country,
  dispatch,
  guardPage,
  isSignIn,
  language,
  render,
}) {
  const [openLoginModal, setOpenLoginModal] = useState(false);

  const handleShowModal = () => {
    setOpenLoginModal((prev) => !prev);
  };

  useEffect(() => {
    if (country !== '' && language !== '') {
      dispatch(retrieveCountriesFromCMS(language));
    }
  }, []);

  useEffect(() => {
    if (isSignIn) setOpenLoginModal(false);
  }, [isSignIn]);

  const shouldGuardRoute = guardPage && !isSignIn;
  return (
    <div>
      { (shouldGuardRoute ? shouldGuardRoute : openLoginModal) && (
        <ModalLogin onCloseLoginModal={ () => setOpenLoginModal(false) } />
      ) }
      { shouldGuardRoute ? (
        <Header
          country={ country }
          language={ language }
          refunds={ true }
          showInformation={ false }
        />
      ) : (
        render({ isSignIn, handleShowModal })
      ) }
    </div>
  );
}

ProtectedRoutes.propTypes = {
  country: PropTypes.string.isRequired,
  dispatch: PropTypes.func,
  guardPage: PropTypes.bool,
  isSignIn: PropTypes.bool,
  language: PropTypes.string.isRequired,
  render: PropTypes.func,
};

const mapStateToProps = (state) => ({
  country: state.LanguageBundle.country,
  language: state.Manage.language,
  isSignIn: state.UserProfileSession.isSignIn,
});

export default connect(mapStateToProps)(ProtectedRoutes);
